import { gold } from '@ant-design/colors';

export default {
  apiDomain: 'api.ecomdatascraper.com',
  homeUrl: 'ecomdatascraper.com',
  company: 'Ecomdatascraper',
  id: 'ecomdatascraper',
  theme: {
    colorPrimary: gold[5],
  },
  contactUsUrl: 'https://ecomdatascraper.com/contact-us/',
  servicesUrl: 'https://ecomdatascraper.com/services/',
  pricingUrl: 'https://ecomdatascraper.com/pricing/',
  faqUrl: 'https://ecomdatascraper.com/faq/',
  tutorialsUrl: 'https://ecomdatascraper.com/category/scraping/tutorials/',
  videosUrl: '',
  communityUrl: null,
  scheduleCallUrl: null,
  termsOfServiceUrl: 'https://ecomdatascraper.com/terms-of-service/',
  googleMapsCategoriesUrl: 'https://ecomdatascraper.com/google-maps-business-categories/',  // TODO make optional
  stripeApiKeys: {
    main: '',
  },
  payPalClientId: '',
  availablePaymentProviders: {
    stripe: false,
    bank: true,
    crypto: true,
  },
  gaToken: '',
  googleClientId: '',
  linkedinClientId: '',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [
    'amazon_products_service', 'biggestbook_products', 'bradyindustries_products', 'boots_products', 'ebay_products', 'macys_products', 'samsclub_products', 'wbmason_products',
    'google_search_shopping_service', 'shopify_products', 'tesco_products', 'vistaprint_products', 'lyreco_products', 'customink_products', 'fastenal_products', 'waxie_products', 'lowes_products',
    'iteminfo_products', 'quill_products', 'staples_products', 'officedepot_products', 'costco_products', 'webstaurantstore_products', 'etsy_products', 'better-businness-products', 'grainger_products', 'walmart_products', 'tiktok_products',
    'otto_products', 'newegg_products', 'cdw_products', 'homedepot_products', 'bestbuy_products', 'decathlon_products', 'uline_products', 'menards_products', 'target_products', 'napaonline_products', 'zoro_products', 'zalando_products',
    'groupon_products', 'gemplers_products', 'globalindustrial_products', 'asos_products', 'olx',
  ],
  learnMoreLinks: {},
  tutorialsLinks: {},
  otherLinks: {},
  integrationsLinks: {}
};

